import { EntityImage } from '@urbanx/agx-ui-components';
import { useGetAllAgencies } from '@urbanx/agx.agencies.client';
import { SelectChipOption } from '@urbanx/agx.ui-components2';
import { useMemo } from 'react';

export const useGetAgencyOptions = (agencyIds?: string[]) => {
  const { data: agencies, isPending: isAgenciesPending } = useGetAllAgencies();

  const agencyOptions = useMemo(() => {
    if (!agencies || agencies.length === 0) {
      return [];
    }

    return agencies.map(
      (agency) =>
        ({
          value: agency.id,
          label: agency.name,
          selected: agencyIds?.includes(agency.id ?? '') ?? false,
          icon: (
            <EntityImage
              addRingToImage={true}
              size={32}
              photoUri={agency.logoUrl}
              name={agency.name}
            />
          ),
        }) as SelectChipOption
    );
  }, [agencyIds, agencies]);

  return { agencyOptions, isAgenciesPending };
};
